<template>
  <div class="py-4">
    <b-container>
      <BDXStatusPendingWrapper>
        <template v-if="showBDXUploader">
          <a
            @click.prevent="() => (showBDXUploader = false)"
            class="float-right small"
            href
            >Close</a
          >
          <div class="mb-2 clearfix"></div>
          <BDXUploader
            @files-uploaded="onBDXFilesUploaded"
            :input-attrs="{ multiple: true }"
            class="mb-3"
          />
        </template>

        <!-- Keyed on ?start= (the menu's Full Data Export / New Report, LIQ-2643): choosing one
             while already here starts that flow in a fresh wizard. -->
        <SaveReportWizard
          v-if="isExportEnabled"
          :key="route.query.start || 'export'"
          @report-exported="() => router.push({ name: 'ExportLog' })"
        />
        <b-alert v-else variant="primary" class="py-2 px-3" show
          >Export feature is in maintenance and will be available
          shortly.</b-alert
        >
      </BDXStatusPendingWrapper>
    </b-container>
  </div>
</template>

<script>
import { defineComponent, ref, watch } from '@vue/composition-api'
import { useRouter, useRoute } from 'vue2-helpers/vue-router'

import { useExport } from '@composables'
import { BDXStatusPendingWrapper, BDXUploader } from '@components/bdx'
import SaveReportWizard from '@components/SaveReportWizard/SaveReportWizard'

export default defineComponent({
  name: 'ExportPage',
  components: {
    BDXStatusPendingWrapper,
    BDXUploader,
    SaveReportWizard
  },
  setup() {
    const router = useRouter()
    const route = useRoute()

    const { isExportEnabled } = useExport()

    const showBDXUploader = ref(false)

    const onBDXFilesUploaded = () => {
      setTimeout(() => {
        showBDXUploader.value = false
      }, 2000)
    }

    watch(
      () => route.query,
      (newQuery) => (showBDXUploader.value = newQuery.upload || false),
      {
        deep: true,
        immediate: true
      }
    )

    return {
      router,
      route,

      isExportEnabled,

      showBDXUploader,
      onBDXFilesUploaded
    }
  }
})
</script>
